import { getAxiosClient } from '../../client';
import { makeApiRequest } from '../../makeApiRequest';
import type { ApiResponse } from '../../responses';
import { PosEndpoints } from './posEndpoints';
import type { IPosService } from './IPosService';
import type { GetPosCatalogResponse } from './responses';

type PosServiceOptions = {
    baseUrl: string;
};

/**
 * Reads the endpoints that exist for the till alone. `GET /pos/catalog` serves
 * the whole sellable catalog for the signed-in branch in one call — no paging,
 * no filters, no cost figures — so the POS never has to reassemble it from the
 * back-office product list.
 */
export class PosService implements IPosService {
    private readonly baseUrl: string;

    constructor({ baseUrl }: PosServiceOptions) {
        this.baseUrl = baseUrl;
    }

    public getCatalog(): Promise<ApiResponse<GetPosCatalogResponse>> {
        const url = PosEndpoints.catalog();
        return makeApiRequest<GetPosCatalogResponse>(
            getAxiosClient({ baseURL: this.baseUrl }).get(url),
        );
    }
}
